import React, { useEffect, useRef } from "react";

const ENTITY_TV_SYMBOL = {
  bitcoin: "BINANCE:BTCUSDT",
  btc: "BINANCE:BTCUSDT",
  ethereum: "BINANCE:ETHUSDT",
  eth: "BINANCE:ETHUSDT",
  litecoin: "BINANCE:LTCUSDT",
  ltc: "BINANCE:LTCUSDT",
  ripple: "BINANCE:XRPUSDT",
  xrp: "BINANCE:XRPUSDT",
  solana: "BINANCE:SOLUSDT",
  sol: "BINANCE:SOLUSDT",
  dogecoin: "BINANCE:DOGEUSDT",
  doge: "BINANCE:DOGEUSDT",
  bnb: "BINANCE:BNBUSDT",
  binancecoin: "BINANCE:BNBUSDT",
  cardano: "BINANCE:ADAUSDT",
  ada: "BINANCE:ADAUSDT",
  tron: "BINANCE:TRXUSDT",
  trx: "BINANCE:TRXUSDT",
  polkadot: "BINANCE:DOTUSDT",
  dot: "BINANCE:DOTUSDT",
  chainlink: "BINANCE:LINKUSDT",
  link: "BINANCE:LINKUSDT",
  avalanche: "BINANCE:AVAXUSDT",
  avax: "BINANCE:AVAXUSDT",
  polygon: "BINANCE:MATICUSDT",
  matic: "BINANCE:MATICUSDT",
  shibainu: "BINANCE:SHIBUSDT",
  shiba: "BINANCE:SHIBUSDT",
  shib: "BINANCE:SHIBUSDT",
};

/** Map admin entity_id / name to a TradingView symbol (Binance USDT pair). */
export function entityToTradingViewSymbol(entityId, entityName) {
  const id = String(entityId || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
  if (id && ENTITY_TV_SYMBOL[id]) return ENTITY_TV_SYMBOL[id];

  const name = String(entityName || "").trim().toLowerCase();
  for (const [key, sym] of Object.entries(ENTITY_TV_SYMBOL)) {
    if (name.includes(key)) return ENTITY_TV_SYMBOL[key];
  }

  if (id) {
    const ticker = id.replace(/coin$/i, "").toUpperCase();
    if (ticker.length >= 2 && ticker.length <= 10) return `BINANCE:${ticker}USDT`;
  }

  return "BINANCE:BTCUSDT";
}

/** Map live-trade period tab to TradingView interval (minutes). */
export function periodToTradingViewInterval(period) {
  switch (String(period || "").trim()) {
    case "30s":
      return "1";
    case "1m":
      return "1";
    case "3m":
      return "3";
    case "5m":
      return "5";
    case "10m":
      return "10";
    case "1h":
      return "60";
    default:
      return "1";
  }
}

export default function TradingViewAdvancedChart({
  symbol = "BINANCE:BTCUSDT",
  theme = "light",
  height = 320,
  interval = "1",
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    const host = containerRef.current;
    if (!host) return undefined;

    host.innerHTML = "";

    const wrapper = document.createElement("div");
    wrapper.className = "tradingview-widget-container";
    wrapper.style.width = "100%";
    wrapper.style.height = "100%";
    wrapper.style.position = "relative";
    wrapper.style.zIndex = "0";

    const widgetDiv = document.createElement("div");
    widgetDiv.className = "tradingview-widget-container__widget";
    widgetDiv.style.width = "100%";
    widgetDiv.style.height = "100%";
    widgetDiv.style.position = "relative";
    widgetDiv.style.zIndex = "0";

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.innerHTML = JSON.stringify({
      autosize: true,
      symbol,
      interval,
      theme,
      locale: "en",
      allow_symbol_change: false,
      calendar: false,
      hide_side_toolbar: true,
      hide_top_toolbar: false,
      hide_legend: false,
      withdateranges: true,
      support_host: "https://www.tradingview.com",
      style: "1",
    });

    wrapper.appendChild(widgetDiv);
    wrapper.appendChild(script);
    host.appendChild(wrapper);

    return () => {
      if (host) host.innerHTML = "";
    };
  }, [symbol, theme, interval]);

  return (
    <div
      ref={containerRef}
      className="tradingview-chart-host rounded border"
      style={{
        width: "100%",
        height,
        minHeight: height,
        maxHeight: height,
        position: "relative",
        zIndex: 0,
        isolation: "isolate",
        overflow: "hidden",
        contain: "layout paint style",
      }}
    />
  );
}
